export default "/images/vendor/flag-icon-css/flags/4x3/mw.svg?b4d805efda655aef8b6e88cb546f2d80";